import React, { useState, useEffect } from 'react';
import { getDeliveryById, updateDeliveryStatus } from '../api';
import { Header, Loader } from '../components';
import { IconMap } from '../Icons';

const OrderItemScreen = ({ navigate, params }) => {
  const { orderId, number, from } = params || {};

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [changing, setChanging] = useState(false);
  const [optimisticDelivered, setOptimisticDelivered] = useState(null);

  const load = async () => {
    setLoading(true);
    try {
      const result = await getDeliveryById(orderId);
      setData(Array.isArray(result) ? result[0] : result);
    } catch {
      setData(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, [orderId]);

  const currentStatus = data?.order?.status;
  const isDelivered = optimisticDelivered !== null
    ? optimisticDelivered
    : (currentStatus === 'Delivered' || currentStatus === 'Closed');

  const handleToggle = async () => {
    if (isDelivered || changing) return;
    const newStatus = currentStatus === 'OnWay' ? 'Delivered' : 'OnWay';
    setOptimisticDelivered(newStatus === 'Delivered');
    setChanging(true);
    try {
      await updateDeliveryStatus(data.id, newStatus);
      await load();
    } catch {
      setOptimisticDelivered(null); // откат при ошибке
    } finally {
      setChanging(false);
      setOptimisticDelivered(null);
    }
  };

  const openYandexMap = () => {
    // const coords = data?.order?.deliveryPoint?.coordinates;
    // if (!coords) return;
    // window.open(`https://maps.yandex.ru/?pt=${coords.longitude},${coords.latitude}`, '_blank');

    const addrText = data?.order?.deliveryPoint?.address.line1;
    if (!addrText) return;
    window.open(`https://maps.yandex.ru/?text=${encodeURIComponent(addrText)}`, '_blank');
  };

  const addr = data?.order?.deliveryPoint?.address;
  const addrText = addr?.line1; 
  // const addrText = addr  
  //   ? `г. ${addr.street?.city?.name}, ул. ${addr.street?.name}, д. ${addr.house}${addr.building ? `, стр. ${addr.building}` : ''}`
  //   : '—';

  return (
    <>
      <Header
        title={`Заказ №${number}`}
        onBack={() => navigate(from === 'history' ? 'history' : 'list')}
      />
      <div className="screen">
        <div className="screen-content" style={{ paddingBottom: 100 }}>
          {loading ? (
            <Loader />
          ) : !data ? (
            <div className="empty-state">Заказ не найден</div>
          ) : (
            <>
              <div className="detail-card">
                {[
                  ['Имя', data.order.customer?.name, null],
                  ['Комментарий', data.order.comment || '', null],
                  ['Сумма', data.order.sum ? `${data.order.sum} р.` : '—', null],
                  ['Тип оплаты:', data.order.payments?.[0]?.paymentType?.name || '', null],
                ].map(([label, value]) => (
                  <div className="detail-row" key={label}>
                    <span className="detail-label">{label}</span>
                    <span className="detail-value">{value}</span>
                  </div>
                ))}

                <div className="detail-row">
                  <span className="detail-label">Адрес</span>
                  <span className="detail-value link" onClick={openYandexMap}>
                    <IconMap /> {addrText}
                  </span>
                </div>

                {/* {[
                  ['Домофон', addr?.doorphone],
                  ['Подъезд', addr?.entrance],
                  ['Квартира', addr?.flat],
                  ['Этаж', addr?.floor],
                ].map(([label, value]) => (
                  <div className="detail-row" key={label}>
                    <span className="detail-label">{label}</span>
                    <span className="detail-value">{value || ''}</span>
                  </div>
                ))} */}

                <div className="detail-row">
                  <span className="detail-label">Телефон</span>
                  <span className="detail-value link" onClick={() => window.open(`tel:${data.order.phone}`)}>
                    {data.order.phone}
                  </span>
                </div>
              </div>

              <div className="section-title">Состав заказа:</div>
              <div className="detail-card">
                {(data.order.items || []).map((item, i) => (
                  <div className="item-row" key={i}>
                    <span className="item-name">{item.product?.name}</span>
                    <span className="item-qty">{item.amount}шт.</span>
                  </div>
                ))}
              </div>

              <div className="toggle-row">
                <span className={`toggle-label${!isDelivered ? ' active' : ''}`}>Заказ в пути</span>
                <div
                  className={`toggle-switch${isDelivered ? ' on' : ''}${isDelivered ? ' disabled' : ''}`}
                  onClick={handleToggle}
                >
                  <div className="toggle-thumb" />
                </div>
                <span className={`toggle-label${isDelivered ? ' active' : ''}`}>Заказ доставлен</span>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default OrderItemScreen;
